import { DashboardConstants, patientAction } from '../../actions/constant';

const {
  GET_ALL_PATIENT_LIST_REQUEST,
  GET_ALL_PATIENT_LIST_SUCCESS,
  GET_ALL_PATIENT_LIST_FAILURE,
  GET_ALL_PATIENT_LIST_LOADING,
  GET_ALL_PATIENT_LIST_RESET,
  PERSISTS_BACK_PATIENT,
  PERSISTS_BACK_PATIENT_CRITERIA,
  PERSIST_PATIENT_STATUS_FILTER,
  PERSIST_PATIENT_ACTIVE_CERT,
} = patientAction;

const intitialstate: any = {
  response: null,
  isGetPatients: false,
  loading: false,
  totalPatient: [],
  currentPage: -1,
  pageNumber: 0,
  clickBackPatientId: '',
  searchName: '',
  payerType: '',
  status: '',
  statusFilter: {
    active: true,
    inactive: false,
  },
  activeCert: {
    PT: false,
    OT: false,
    SLP: false,
  },
};

export const getAllPatientListReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_ALL_PATIENT_LIST_SUCCESS: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          isGetPatients: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatient: [...state.totalPatient, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          isGetPatients: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatient: action.payload?.data?.content || [],
        };
      }
    }

    case GET_ALL_PATIENT_LIST_FAILURE:
      return {
        ...state,
        isGetPatients: false,
        response: action.payload,
        loading: false,
      };

    case PERSISTS_BACK_PATIENT:
      return {
        ...state,
        clickBackPatientId: action.payload,
      };

    case PERSISTS_BACK_PATIENT_CRITERIA:
      return {
        ...state,
        searchName: action.payload.searchName,
        payerType: action.payload.payerType,
        status: action.payload.status,
      };

    case PERSIST_PATIENT_STATUS_FILTER:
      const newState = {
        ...state,
        statusFilter: action.payload,
      };
      return newState;

    case PERSIST_PATIENT_ACTIVE_CERT:
      return {
        ...state,
        activeCert: action.payload,
      };

    case GET_ALL_PATIENT_LIST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_PATIENT_LIST_RESET:
      return {
        ...intitialstate,
        statusFilter: state.statusFilter,
        activeCert: state.activeCert,
      };

    default:
      return state;
  }
};
